import { render, staticRenderFns } from "./FormStep3.vue?vue&type=template&id=1b8a5eac&scoped=true&"
import script from "./FormStep3.vue?vue&type=script&lang=js&"
export * from "./FormStep3.vue?vue&type=script&lang=js&"
import style0 from "./FormStep3.vue?vue&type=style&index=0&id=1b8a5eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a5eac",
  null
  
)

/* custom blocks */
import block0 from "./FormStep3.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports